import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

// Gallery images
const galleryImages = [
  {
    src: "/images/gallery/WigInstall1.jpg",
    alt: "Wig install 1",
    category: "Wig Install",
  },
  {
    src: "/images/gallery/WigInstall2.jpg",
    alt: "Wig install 2",
    category: "Wig Install",
  },
  {
    src: "/images/gallery/WigInstall3.jpg",
    alt: "Wig install 3",
    category: "Wig Install",
  },
  {
    src: "/images/gallery/WigInstall4.jpg",
    alt: "Wig install 4",
    category: "Wig Install",
  },
  {
    src: "/images/gallery/WigInstall5.jpg",
    alt: "Wig install 5",
    category: "Wig Install",
  },
  {
    src: "/images/gallery/WigInstall6.jpg",
    alt: "Wig install 6",
    category: "Wig Install",
  },
  {
    src: "/images/gallery/WigInstall7.jpg",
    alt: "Wig install 7",
    category: "Wig Install",
  },
  {
    src: "/images/gallery/WigInstall8.jpg",
    alt: "Wig install 8",
    category: "Wig Install",
  },
  {
    src: "/images/gallery/TraditionalSewIn1.jpg",
    alt: "Traditional sew-in 1",
    category: "Traditional sew-ins",
  },
  {
    src: "/images/gallery/TraditionalSewIn2.jpg",
    alt: "Traditional sew-in 2",
    category: "Traditional sew-ins",
  },
  {
    src: "/images/gallery/TraditionalSewIn3.jpg",
    alt: "Traditional sew-in 3",
    category: "Traditional sew-ins",
  },
  {
    src: "/images/gallery/TraditionalSewIn4.jpg",
    alt: "Traditional sew-in 4",
    category: "Traditional sew-ins",
  },
  {
    src: "/images/gallery/TraditionalSewIn5.jpg",
    alt: "Traditional sew-in 5",
    category: "Traditional sew-ins",
  },
  {
    src: "/images/gallery/ClosureSewIns1.jpg",
    alt: "Closure sew-in 1",
    category: "Closure sew-ins",
  },
  {
    src: "/images/gallery/ClosureSewIns2.jpg",
    alt: "Closure sew-in 2",
    category: "Closure sew-ins",
  },
  {
    src: "/images/gallery/ClosureSewIns3.jpg",
    alt: "Closure sew-in 3",
    category: "Closure sew-ins",
  },
  {
    src: "/images/gallery/ClosureSewIns4.jpg",
    alt: "Closure sew-in 4",
    category: "Closure sew-ins",
  },
  {
    src: "/images/gallery/ClosureSewIns5.jpg",
    alt: "Closure sew-in 5",
    category: "Closure sew-ins",
  },
  {
    src: "/images/gallery/ClosureQW1.jpg",
    alt: "Closure quickweave 1",
    category: "Closure quickweaves",
  },
  {
    src: "/images/gallery/ClosureQW2.jpg",
    alt: "Closure quickweave 2",
    category: "Closure quickweaves",
  },
  {
    src: "/images/gallery/ClosureQW3.jpg",
    alt: "Closure quickweave 3",
    category: "Closure quickweaves",
  },
  {
    src: "/images/gallery/ClosureQW4.jpg",
    alt: "Closure quickweave 4",
    category: "Closure quickweaves",
  },
  {
    src: "/images/gallery/ClosureQW5.jpg",
    alt: "Closure quickweave 5",
    category: "Closure quickweaves",
  },
  {
    src: "/images/gallery/QW_PT1.jpg",
    alt: "Quickweave ponytail 1",
    category: "Quickweave/ponytails",
  },
  {
    src: "/images/gallery/QW_PT2.jpg",
    alt: "Quickweave ponytail 2",
    category: "Quickweave/ponytails",
  },
  {
    src: "/images/gallery/QW_PT3.jpg",
    alt: "Quickweave ponytail 3",
    category: "Quickweave/ponytails",
  },
  {
    src: "/images/gallery/QW_PT4.jpg",
    alt: "Quickweave ponytail 4",
    category: "Quickweave/ponytails",
  },
  {
    src: "/images/gallery/QW_PT5.jpg",
    alt: "Quickweave ponytail 5",
    category: "Quickweave/ponytails",
  },
  {
    src: "/images/gallery/FrontalPonytail1.jpg",
    alt: "Frontal ponytail 1",
    category: "Frontal ponytails",
  },
  {
    src: "/images/gallery/FrontalPonytail2.jpg",
    alt: "Frontal ponytail 2",
    category: "Frontal ponytails",
  },
  {
    src: "/images/gallery/FrontalPonytail3.jpg",
    alt: "Frontal ponytail 3",
    category: "Frontal ponytails",
  },
];

const categories = [
  "All",
  "Wig Install",
  "Traditional sew-ins",
  "Closure sew-ins",
  "Closure quickweaves",
  "Quickweave/ponytails",
  "Frontal ponytails",
];
const IMAGE_VERSION = "20260312";

export default function GalleryPage() {
  const [filter, setFilter] = useState("All");
  const revealRefs = useRef([]);
  const observerRef = useRef(null);
  
  const filteredImages =
    filter === "All"
      ? galleryImages
      : galleryImages.filter((img) => img.category === filter);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          }
        });
      },
      { threshold: 0.1 }
    );

    revealRefs.current.forEach((el) => {
      if (el) observerRef.current.observe(el);
    });

    return () => observerRef.current?.disconnect();
  }, [filter]);

  const addRevealRef = (el) => {
    if (el && !revealRefs.current.includes(el)) {
      revealRefs.current.push(el);
      if (observerRef.current) observerRef.current.observe(el);
    }
  };

  return (
    <div className="bg-[#F0F0F0] min-h-screen">
      {/* Header */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center">
          <h1 className="script-heading text-3xl md:text-4xl mb-4">
            Gallery
          </h1>
          <p className="text-[#666] max-w-lg mx-auto">
            Browse my portfolio of stunning transformations. Each image 
            represents my commitment to excellence and artistry.
          </p>
        </div>
      </section>

      {/* Filter */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8">
        <div className="flex flex-wrap justify-center gap-2">
          {categories.map((category) => (
            <button
              key={category}
              data-testid={`filter-${category.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              onClick={() => setFilter(category)}
              className={`px-4 py-2 rounded-full text-sm transition-all ${
                filter === category
                  ? "bg-[#111111] text-white"
                  : "bg-white text-[#111111] hover:bg-gray-100"
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      </section>

      {/* Gallery Grid */}
      <section 
        data-testid="gallery-section" 
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16"
      >
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {filteredImages.map((image, index) => (
            <div
              key={`${image.src}-${index}`}
              ref={addRevealRef}
              data-testid={`gallery-image-${index}`}
              className="rounded-xl overflow-hidden image-hover-zoom aspect-[3/4] animate-fade-in-up"
              style={{ animationDelay: `${(index % 4) * 100}ms` }}
            >
              <img
                src={`${image.src}?v=${IMAGE_VERSION}`}
                alt={image.alt}
                className="w-full h-full object-cover"
                loading={index < 4 ? "eager" : "lazy"}
                decoding="async"
                fetchPriority={index < 4 ? "high" : "low"}
                sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw"
              />
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="glass-card p-8 text-center">
          <h2 className="script-heading text-2xl mb-4">
            Ready to Be Our Next Transformation?
          </h2>
          <p className="text-[#666] mb-6">
            Book your appointment today and let us create your perfect look.
          </p>
          <Link
            to="/book"
            data-testid="gallery-cta-book-btn"
            className="btn-black inline-block"
          >
            Book Appointment
          </Link>
        </div>
      </section>
    </div>
  );
}
